import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Footer from "./Components/Footer";
import Contact from "./Components/Contact";
import CustomError404 from "./Components/CustomError404";
import Login from "./Pages/auth/Login";
import Register from "./Pages/auth/Register";
import VerifyMobile from "./Pages/auth/VerifyMobile";
import VerifyEmail from "./Pages/auth/VerifyEmail";
import MyProfile from "./Pages/Profile/MyProfile";
import AddAuditor from "./Pages/Auditor/AddAuditor";
import PublishJobList from "./Pages/Publish/PublishJobList";
import Navbar from "./Components/Navbar";
import AuditorList from "./Pages/Auditor/AuditorList";
import ProtectedRoutes from "./Components/ProtectedRoutes";
import JobOpening from "./Pages/Opening/JobOpening";
import Notification from "./Pages/Dashboard/Notification";
import ViewAuditor from "./Pages/Auditor/ViewAuditor";
import { ToastContainer } from "react-toastify";
import ViewPublishJob from "./Pages/Publish/ViewPublishJob";
import JobDetail from "./Pages/Opening/JobDetail";
import ViewApplicantDetails from "./Pages/Profile/ViewApplicantDetails";
import ScrollToTop from "./Helper/ScrollToTop";
import AddNewJob from "./Pages/Publish/AddNewJob";
import { Navigate, useParams } from "react-router-dom";
import TermsCondition from "./Pages/Dashboard/TermsCondition";
import ReferralLanding from "./Pages/Dashboard/ReferralLanding";
import PrivacyPolicy from "./Pages/Dashboard/PrivacyPolicy";
import AboutUs from "./Pages/Dashboard/AboutUs";
import HomePage from "./Pages/Dashboard/HomePage";
import CityMailer from "./Pages/Publish/CityMailer";
import MailAuditors from "./Pages/Publish/MailAuditors";
import FirstVisitPopup from "./Components/FirstVisitPopup";
import Blogs from "./Pages/Blogs/Blogs";
import BlogDetail from "./Pages/Blogs/BlogDetail";

const RegisterWrapper = () => {
  const { refercode } = useParams();
  const isAuthenticated = () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      return user && user.fld_name;
    } catch (error) {
      return false;
    }
  };
  return isAuthenticated() ? (
    <Navigate to="/" replace />
  ) : (
    <Register refercode={refercode} />
  );
};

const MainMenu = () => {
  // Mock function to check if the user is logged in
  const isAuthenticated = () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      return user && user.fld_name;
    } catch (error) {
      return false;
    }
  };
  return (
    <div className="App">
      <ToastContainer />

      {/* <FirstVisitPopup /> */}
      <Navbar />
      <ScrollToTop />
        <Routes>
          {/* <Route exact path="/" element={<Home />} /> */}
          <Route exact path="/" element={<HomePage />} />
          <Route exact path="/jobs-opening-list" element={<JobOpening />} />
          <Route exact path="/terms-condition" element={<TermsCondition />} />
          <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route exact path="/refer-earn" element={<ReferralLanding />} />
          <Route exact path="/About-us" element={<AboutUs />} />
          <Route exact path="/blogs" element={<Blogs />} />
          <Route exact path="/blog/:id" element={<BlogDetail />} />
          <Route exact path="/jobdetails/:id/:name" element={<JobDetail />} />

          <Route
            exact
            path="/view-applicant-detail"
            element={<ViewApplicantDetails />}
          />
          <Route exact path="/contactus" element={<Contact />} />
          {/* <Route exact path="/login" element={<Login />} /> */}
          {/* <Route exact path="/admin-login" element={<Login />} /> */}
          <Route
            exact
            path="/login"
            element={isAuthenticated() ? <Navigate to="/" replace /> : <Login />}
          />

          <Route
            exact
            path="/admin-login"
            element={isAuthenticated() ? <Navigate to="/" replace /> : <Login />}
          />
          <Route
            exact
            path="/register/:refercode"
            element={<RegisterWrapper />}
          />
          <Route
            exact
            path="/register"
            element={isAuthenticated() ? <Navigate to="/" replace /> : <Register />}
          />
          <Route
            exact
            path="/verifymobile"
            element={isAuthenticated() ? <Navigate to="/" replace /> : <VerifyMobile />}
          />
          <Route
            exact
            path="/verifyemail"
            element={isAuthenticated() ? <Navigate to="/" replace /> : <VerifyEmail />}
          />

          <Route exact path="/account" element={<ProtectedRoutes requiredRole={["Staff", "Seeker", "Auditor", "Recruiter"]}><MyProfile /></ProtectedRoutes>} />
          <Route exact path="/notification" element={<ProtectedRoutes requiredRole={["Staff", "Seeker", "Auditor", "Recruiter"]}><Notification /></ProtectedRoutes>} />
          {/* <Route exact path="/audits-opening-list" element={<ProtectedRoutes requiredRole={["Staff", "Auditor", "Recruiter","Seeker"]}><AuditOpening /></ProtectedRoutes>} /> */}
          <Route exact path="/add-auditor" element={<ProtectedRoutes requiredRole={["Staff"]}><AddAuditor /></ProtectedRoutes>} />
          <Route exact path="/view-auditor/:id" element={<ProtectedRoutes requiredRole={["Staff"]}><ViewAuditor /></ProtectedRoutes>} />
          <Route exact path="/edit/:id" element={<ProtectedRoutes requiredRole={["Staff", "Seeker", "Auditor", "Recruiter"]}><ViewAuditor /></ProtectedRoutes>} />
          <Route exact path="/auditor-list" element={<ProtectedRoutes requiredRole={["Staff"]}><AuditorList /></ProtectedRoutes>} />
          {/* <Route exact path="/publish-audit" element={<ProtectedRoutes requiredRole={['Staff','Recruiter']}><PublishAuditList /></ProtectedRoutes>} /> */}
          {/* <Route exact path="/view-publish-audit" element={<ProtectedRoutes requiredRole={["Staff", "Recruiter"]}><ViewPublishAudit /></ProtectedRoutes>} /> */}
          <Route exact path="/publish-job" element={<ProtectedRoutes requiredRole={["Staff", "Recruiter"]}><PublishJobList /></ProtectedRoutes>} />
          <Route exact path="/add-new-job" element={<ProtectedRoutes requiredRole={["Staff", "Recruiter"]}><AddNewJob /></ProtectedRoutes>} />
          <Route exact path="/view-publish-job" element={<ProtectedRoutes requiredRole={["Staff", "Recruiter"]}><ViewPublishJob /></ProtectedRoutes>} />
          <Route exact path="/mail-auditors/:jobCode" element={<ProtectedRoutes requiredRole={["Staff", "Seeker", "Auditor", "Recruiter"]}><MailAuditors /></ProtectedRoutes>} />
          <Route exact path="/city-mailers" element={<ProtectedRoutes requiredRole={["Staff", "Seeker", "Auditor", "Recruiter"]}><CityMailer /></ProtectedRoutes>} />

          <Route element={<CustomError404 />} />
        </Routes>
      <Footer />
    </div>
  );
};

export default MainMenu;
